import { render } from "./SideBarLayout.vue?vue&type=template&id=bfc2d822&scoped=true"
import script from "./SideBarLayout.vue?vue&type=script&lang=js"
export * from "./SideBarLayout.vue?vue&type=script&lang=js"

import "./SideBarLayout.vue?vue&type=style&index=0&id=bfc2d822&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfc2d822"]])

export default __exports__